import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import allowance from "../../../containers/modules/hr/allowance";

export default function AllowanceRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="allowance"
      index
      element={
        <AccessControl
          name={"Allowance List"}
          auth={authUser}
          component={allowance}
        />
      }
    ></Route>
  );
}
